import { flow } from 'lodash';
import ModalCards from './ModalCards';
import withUserInput from '../../hocs/UserInput';
import withPager from '../../hocs/Pager';

export default flow(withUserInput, withPager)(ModalCards);



// WEBPACK FOOTER //
// ../core/src/components/ModalCards/index.js